import React from "react";
import { ArrowRight, Ruler, Wrench, Award } from "lucide-react";
import useReveal from "../hooks/useReveal";

const points = [
  { icon: Ruler, text: "Free space planning & gym design" },
  { icon: Wrench, text: "Qualified mechanical engineering staff" },
  { icon: Award, text: "20+ years design experience" },
];

export default function BuildGym() {
  const ref = useReveal();
  return (
    <section className="bg-white py-16">
      <div ref={ref} className="reveal mx-auto grid max-w-7xl items-center gap-10 px-4 lg:grid-cols-2 lg:px-8">
        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-brand">Our Service</p>
          <h2 className="font-heading text-3xl font-extrabold text-navy md:text-4xl">
            Build your Dream Gym
          </h2>
          <p className="mt-4 text-navy/70">
            Whether you&rsquo;re setting up a garage gym or a commercial facility, Cyberfit is here
            to help. We provide expert advice and free gym design services to ensure you maximise
            your space.
          </p>
          <p className="mt-3 text-navy/70">
            When you choose Cyberfit, you&rsquo;re selecting an Australian-owned company with a
            passion for fitness and the engineering know-how to back it up.
          </p>
          <ul className="mt-6 space-y-3">
            {points.map((pt) => (
              <li key={pt.text} className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sky text-navy">
                  <pt.icon size={18} />
                </span>
                <span className="text-sm font-medium text-navy">{pt.text}</span>
              </li>
            ))}
          </ul>
          <a
            href="#showroom"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-3 font-heading font-bold text-white transition-colors hover:bg-brand-dark"
          >
            Get Started <ArrowRight size={16} />
          </a>
        </div>
        <div className="relative overflow-hidden rounded-3xl shadow-xl">
          <img
            src="/images/173e9eeed58e.jpg"
            alt="Dream gym setup"
            className="h-full max-h-[460px] w-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}
